import { baseEnvironment } from './base.environment';

export const environment = {
  ...baseEnvironment,
  title: 'CR LINC',
  oktaAuthIssuerURL: 'https://tcenergyhub.okta.com/oauth2/default',
  oktaClientId: '0oa2vqh90x7LwYmP9697',
  graphQLUrl: 'https://api-flask.crlinc.tcenergy.com/graphql',
  fieldVisionUrl: 'https://fv.crlinc.tcenergy.com/',
  publicFunctionApiKey: 'da2-s7m7tj2mzfe2thxgnoor2rb2yu',
};
